import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { getErrorByField } from "../Api/auth";
import { Spinner } from "react-bootstrap";
import { getUserById, activeuser } from "../Api/auth";
import { SITE_URL } from "../Api/config";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./activeaccount.css";
import { Link } from "react-router-dom";
import { API_URL } from "../Api/config";
import { apiCallNoForm } from "../Api/auth";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";

function Activeaccount() {
  const [apicall, setApicall] = useState(false);
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const key = queryParams.get("key");
  const iv = queryParams.get("iv");

  const [errors, setErrors] = useState([]);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [accountStatus, setAccountStatus] = useState(0);

  const [profileStatus, setProfileStatus] = useState(0);

  const [roleid, setRoleId] = useState(0);


  const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
  };

  const [formData, setFormData] = useState(initData);

  const dataChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApicall(true);
    const data = {
      user_id: iv,
      password: password,
      confirmPassword: formData.confirmPassword,
      address: address,
      city: city,
      state: state,
      zip: zip,
      role_id: roleid,
    };
    activeuser(data)
      .then((res) => {
        console.log("res", res);
        if (!res.data.status) {
          setErrors(res.data.error);
        } else {
          setApicall(false);
          setValidated(false);
          //window.location.href = SITE_URL;
          handleloginSubmit(formData.email, password)
        }
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {
        setApicall(false);
      });
    setValidated(false);
  };

  const handleloginSubmit = async (email, password) => {
    setApicall(true);
    apiCallNoForm(API_URL + "user/login", "POST", { email: email, password: password }).then((res) => {
      if (!res.data.status) { setErrors(res.data.error); }
      else {
        localStorage.setItem("user", JSON.stringify(res.data.data));
        const role_id = res.data.data.user.role_id;
        // window.location.href = "/dashboard"
        if (role_id === 4) {
          window.location.href = "/user-dashboard"
        } else if (role_id === 1) {
          window.location.href = "/fitter-dashboard"
        } else if (role_id === 8) {
          window.location.href = "/fitter-builder-dashboard"
        } else if (role_id === 7) {
          window.location.href = "/builder-dashboard"
        }
        else {
          window.location.href = "/dashboard"
        }
      }
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setApicall(false);
    });
    setValidated(true);
  }

  useEffect(() => {
    if (token && key && iv) {
      getUserById({ _id: iv })
        .then((res) => {
          if (res?.code === 200) {
            setFormData(res.data.data);
            setAddress(res.data.data.address);
            setCity(res.data.data.city);
            setState(res.data.data.state);
            setZip(res.data.data.zip);
            setRoleId(res.data.data.role_id);
            if (res.data.data.account_status && res.data.data.account_status === 1) {
              setAccountStatus(1);
            }
            //setProfileStatus(res.data.data.profile_status);
          } else {
            alert(res.data?.message);
          }
        })
        .catch((err) => {
          alert(err);
          console.log("Error: " + err)
        }).finally(() => {
          setIsLoading(false);
        });
    }
  }, [token]);



  return (
    <>
      {
        isLoading ? <Loader2 /> :
          <>
            <style>
              {`
                    form input::placeholder {
                        color: #ffffff;
                    }
                `}
            </style>
            <Container
              className="text-white"
              style={{
                maxWidth: "500px",
                backgroundColor: "#1e2025",
                padding: "2rem",
                borderRadius: "10px",
              }}
            >
              <div className="text-center mb-4">
                <img
                  src={require("../assets/images/logo_text.png")}
                  style={{ width: "60%" }}
                  alt="Logo"
                />

                <p
                  style={{
                    fontFamily: "Barlow",
                    marginTop: "20px",
                    fontSize: "29px",
                    fontWeight: "900",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "0.73px",
                    textAlign: "center",
                    color: "#fff",
                  }}
                >
                  {
                    profileStatus === 0 && ("Complete your profile so that you can log in.")
                  }
                </p>
              </div>
              {
                accountStatus === 0 ? (
                  <Form noValidate validated={validated} onSubmit={handleSubmit} className="active-account">
                    <h5>Your Information</h5>
                    <Row className="mb-3">
                      <Col>
                        <Form.Group controlId="formFirstName">
                          <Form.Control
                            type="text"
                            placeholder="First name"
                            className={`form-control dashboard-input-box-3 me-1  ${errors.length > 0
                              ? getErrorByField(errors, "firstname").length > 0
                                ? "is-invalid"
                                : ""
                              : ""
                              }`}
                            disabled
                            value={formData.firstname}
                            name={"firstname"}
                            onChange={(e) => dataChange(e)}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="formLastName">
                          <Form.Control
                            type="text"
                            placeholder="Last name"
                            className={`form-control dashboard-input-box-3 me-1  ${errors.length > 0
                              ? getErrorByField(errors, "lastname").length > 0
                                ? "is-invalid"
                                : ""
                              : ""
                              }`}
                            disabled
                            value={formData.lastname}
                            name={"lastname"}
                            onChange={(e) => dataChange(e)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group controlId="formPhone" className="mb-3">
                      <Form.Control
                        type="number"
                        placeholder="Phone Number"
                        required
                        disabled
                        className={`form-control dashboard-input-box ${errors.length > 0
                          ? getErrorByField(errors, "phone").length > 0
                            ? "is-invalid"
                            : ""
                          : ""
                          }`}
                        value={formData.phone}
                        name={"phone"}
                        onChange={(e) => dataChange(e)}
                      />
                    </Form.Group>

                    <Form.Group controlId="formEmail" className="mb-3">
                      <Form.Control
                        type="email"
                        className={`form-control dashboard-input-box-3 ${getErrorByField(errors, "email").length > 0
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Email Address"
                        name="email"
                        required
                        disabled
                        value={formData.email}
                        onChange={(e) => dataChange(e)}
                      />
                    </Form.Group>



                    <h5>Password</h5>
                    <Form.Group controlId="formPassword" className="mb-3">
                      <Form.Control
                        type="password"
                        placeholder="Password"
                        required
                        className={`form-control active-pass dashboard-input-box  ${errors.length > 0
                          ? getErrorByField(errors, "password").length > 0
                            ? "is-invalid"
                            : ""
                          : ""
                          }`}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Control.Feedback type="invalid">
                      {errors.length > 0
                        ? getErrorByField(errors, "password").map((item) => {
                          return item.message;
                        })
                        : "Please enter password"}
                    </Form.Control.Feedback>

                    <Form.Group controlId="formConfirmPassword" className="mb-4">
                      <Form.Control
                        type="password"
                        required
                        className={`form-control dashboard-input-box  ${errors.length > 0
                          ? getErrorByField(errors, "confirmPassword").length > 0
                            ? "is-invalid"
                            : ""
                          : ""
                          }`}
                        placeholder="Confirm Password"
                        value={formData.confirmPassword}
                        name={"confirmPassword"}
                        onChange={(e) => dataChange(e)}
                      />
                    </Form.Group>

                    <Form.Control.Feedback type="invalid">
                      {errors.length > 0
                        ? getErrorByField(errors, "confirmPassword").map((item) => {
                          return item.message;
                        })
                        : "Please enter confirmPassword"}
                    </Form.Control.Feedback>

                    {
                      roleid !== 8 && <>
                        <h5>Shipping Address</h5>
                        <Form.Group id="formAddress" className="mb-3">
                          <Form.Control
                            id="address"
                            type="text"
                            placeholder="Address"
                            required
                            autoComplete="address-line1"
                            className={`form-control dashboard-input-box-3 ${errors.length > 0
                              ? getErrorByField(errors, "address").length > 0
                                ? "is-invalid"
                                : ""
                              : ""
                              }`}
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                          {errors.length > 0 && getErrorByField(errors, "address").length > 0 && (
                            <div className="invalid-feedback">
                              {getErrorByField(errors, "address")[0].message}
                            </div>
                          )}
                        </Form.Group>

                        <Row className="mb-3">
                          <div className="col-4 col-md-6 form-group">
                            <Form.Group id="formCity">
                              <Form.Control
                                id="city"
                                type="text"
                                placeholder="City"
                                required
                                autoComplete="address-level2"
                                className={`form-control dashboard-input-box-3 ${errors.length > 0
                                  ? getErrorByField(errors, "city").length > 0
                                    ? "is-invalid"
                                    : ""
                                  : ""
                                  }`}
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                              />
                              {errors.length > 0 && getErrorByField(errors, "city").length > 0 && (
                                <div className="invalid-feedback">
                                  {getErrorByField(errors, "city")[0].message}
                                </div>
                              )}
                            </Form.Group>
                          </div>
                          <Col>
                            <Form.Group id="formZip">
                              <Form.Control
                                id="zip"
                                type="text"
                                placeholder="Zip"
                                autoComplete="postal-code"
                                name="postal-code"
                                required
                                className={`form-control dashboard-input-box-3 ${errors.length > 0
                                  ? getErrorByField(errors, "zip").length > 0
                                    ? "is-invalid"
                                    : ""
                                  : ""
                                  }`}
                                value={zip}
                                onChange={(e) => setZip(e.target.value)}
                              />
                              {errors.length > 0 && getErrorByField(errors, "zip").length > 0 && (
                                <div className="invalid-feedback">
                                  {getErrorByField(errors, "zip")[0].message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group id="formState">
                              <Form.Control
                                id="state"
                                type="text"
                                placeholder="State"
                                required
                                autoComplete="address-level1"
                                className={`form-control dashboard-input-box-3 ${errors.length > 0
                                  ? getErrorByField(errors, "state").length > 0
                                    ? "is-invalid"
                                    : ""
                                  : ""
                                  }`}
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                              />
                              {errors.length > 0 && getErrorByField(errors, "state").length > 0 && (
                                <div className="invalid-feedback">
                                  {getErrorByField(errors, "state")[0].message}
                                </div>
                              )}
                            </Form.Group>
                          </Col>


                        </Row>
                      </>
                    }

                    <Button variant="success" type="submit" className="w-100">
                      {apicall ? (
                        <Spinner animation="border" className="border-black" />
                      ) : (
                        <span>Activate Your Account</span>
                      )}
                    </Button>
                  </Form>
                ) : (
                  <div className="text-center">
                    <h5>You have already activated your account.</h5>
                    <Button variant="success" type="submit" className="w-100"> <Link to={`/`}>Goto home</Link></Button>
                  </div>
                )
              }

            </Container>
          </>
      }
    </>
  );
}

export default Activeaccount;
